import { Button, Card, Image } from "antd";
import { CardHeader } from "Components/Atoms/CardHeader";
import React from "react";
import { toast } from "react-toastify";
import AdminServices from "services/api/AdminServices";


export default function UploadImgToCDN() {

    const [uploadingImg, setUploadingImg] = React.useState(false);
    const [file, setFile] = React.useState(null);
    const [imagePreview, setImagePreview] = React.useState(null);

    const handleFileInputChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setImagePreview(URL.createObjectURL(selectedFile));
        }
    };

    const handleUpload = async () => {
        setUploadingImg(true);
        const data = new FormData();
        data.append('file', file);
        let res = await AdminServices.updateToS3({ fileName: file.name, data, folderName: 'app-images/imgs/sharpely-asset/Campaign' });
        if (res?.type === true && res?.data === 'success') {
            toast.success('Image uploaded!');
            setFile(null);
            setImagePreview(null);
        }
        else {
            toast.error('Something went wrong!');
        }
        setUploadingImg(false);
    }

    return (
        <React.Fragment>
            <Card title={
                <CardHeader heading={'Upload Image'} />
            }>
                <div>
                    <div className="margin20Bottom">
                        <input type="file" onChange={handleFileInputChange} accept="image/*" />
                    </div>
                    {imagePreview && <div className="margin20Bottom">
                        <Image src={imagePreview} style={{ width: "20rem" }} />
                    </div>}
                    <Button type="primary" disabled={!imagePreview} loading={uploadingImg} onClick={() => {
                        handleUpload();
                    }}>Upload</Button>
                </div>
            </Card>
        </React.Fragment>
    )
}